﻿export class CorpForm {

  constructor(form: HTMLElement) {
    this.initFloatingLabels(form);
  }

  private initFloatingLabels(form: HTMLElement) {
    const inputs = form.getElementsByTagName('input');
    for (let i = 0; i < inputs.length; i++) {
      this.initFloatingLabelCss(inputs[i]);
      this.addFloatingLabelHandler(inputs[i]);
    }
    const textareas = form.getElementsByTagName('textarea');
    for (let i = 0; i < textareas.length; i++) {
      this.initFloatingLabelCss(textareas[i]);
      this.addFloatingLabelHandler(textareas[i]);
    }
  }

  private initFloatingLabelCss(el: HTMLInputElement | HTMLTextAreaElement) {
    const value = el.value;
    if (value) {
      el.classList.add('not-empty');
    } else {
      el.classList.remove('not-empty');
    }
  }

  private addFloatingLabelHandler(el: HTMLElement) {
    el.onchange = (e: Event) => {
      const el = e.target as HTMLInputElement;
      this.initFloatingLabelCss(el);
    };
  }
}
